import axios from "axios";

const state = {
  towns: null,
  town: null,
};

const getters = {
  StateTowns: (state) => state.towns,
  StateTown: (state) => state.town,
};

const actions = {
  async GetTowns({ commit }) {
    let response = await axios.get("towns");
    commit("setTowns", response.data["hydra:member"]);
  },

  async GetTown({ commit }, townId) {
    let response = await axios.get("towns/" + townId);
    commit("setTown", response.data);
  },
  async GetTownBySlug({ commit }, slug) {
    const response = await axios.get("towns?slug=" + encodeURIComponent(slug));
    const towns = response.data["hydra:member"];

    if (!towns || towns.length === 0) {
      commit("setTown", null);
      return;
    }

    const town = towns[0];
    const townResponse = await axios.get("towns/" + town.id);
    commit("setTown", townResponse.data);
  },
  async GetTownByTown({ commit }, townName) {
    const response = await axios.get(
      "towns?town=" + encodeURIComponent(townName)
    );
    const towns = response.data["hydra:member"];

    if (!towns || towns.length === 0) {
      commit("setTown", null);
      return;
    }

    const town = towns[0];
    const townResponse = await axios.get("towns/" + town.id);
    commit("setTown", townResponse.data);
  },

  async CreateTown({ dispatch }, town) {
    await axios.post("towns", town);
    return await dispatch("GetTowns");
  },

  async UpdateTown({ dispatch }, data) {
    await axios.put("towns/" + data.id, data);
    return await dispatch("GetTowns");
  },

  async DeleteTown({ dispatch }, townId) {
    await axios.delete("towns/" + townId);
    return await dispatch("GetTowns");
  },
};

const mutations = {
  setTowns(state, towns) {
    state.towns = towns;
  },
  setTown(state, town) {
    state.town = town;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
